const ManagementDashboard = () => {
  return (
    <div style={{ padding: 40 }}>
      <h1>Management Dashboard</h1>
      <p>Welcome. Features coming soon.</p>
    </div>
  );
};

export default ManagementDashboard;